import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import MediaEditor from 'components/MediaEditor';
import RoomEditMain from 'components/RoomEditMain';

import { RoomEditTabs_room$key } from '__generated__/RoomEditTabs_room.graphql';
import { RoomEditTabs_data$key } from '__generated__/RoomEditTabs_data.graphql';

type Props = {
  room: RoomEditTabs_room$key;
  data: RoomEditTabs_data$key;
};

const RoomEditTabs: FC<Props> = props => {
  const room = useFragment(
    graphql`
      fragment RoomEditTabs_room on Room {
        media(first: 2147483647) {
          pageInfo {
            total
          }
        }

        ...RoomEditMain_room
        ...MediaEditor_mediable
      }
    `,
    props.room
  );

  const data = useFragment(
    graphql`
      fragment RoomEditTabs_data on Query {
        ...RoomEditMain_data
      }
    `,
    props.data
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          hash: 'main',
          component: <RoomEditMain room={room} data={data} />,
        },
        {
          title: `Nuotraukos [${room.media?.pageInfo.total ?? 0}]`,
          hash: 'media',
          component: <MediaEditor mediable={room} />,
        },
      ]}
    />
  );
};

export default RoomEditTabs;
